import type { ParticipanteResumen } from './participanteLookupTypes.ts';

/**
 * Spanish UX notice when the active location commune differs from the participant's registered commune.
 */
export function participanteComunaRegistroAviso(
  ubicacionComunaId: number,
  participante: Pick<ParticipanteResumen, 'comunaId' | 'comunaNombre'>,
): string {
  const loc = Number(ubicacionComunaId);
  const pc = Number(participante.comunaId);
  if (!Number.isFinite(loc) || loc <= 0) return '';
  if (!Number.isFinite(pc) || pc <= 0) return '';
  if (loc === pc) return '';
  const nm = participante.comunaNombre?.trim() ?? '';
  const label = nm.length > 0 ? nm : `comuna #${pc}`;
  return `El participante está registrado en ${label}.`;
}

/**
 * Modal/form validation: non-empty when save must be rejected (commune differs from active location).
 */
export function participanteComunaRegistroValidationBlockMessage(
  ubicacionComunaId: number,
  participante: Pick<ParticipanteResumen, 'comunaId' | 'comunaNombre'> | null | undefined,
): string {
  if (participante == null) return '';
  const base = participanteComunaRegistroAviso(ubicacionComunaId, participante);
  return base ? `${base} No se puede agregar el participante.` : '';
}
